































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import ModalTabelaPrestador from '@/components/RemuneracaoMedica/contratos/modais/ModalTabelaPrestador.vue'
import ModalTabelaProfissional from '@/components/RemuneracaoMedica/contratos/modais/ModalTabelaProfissional.vue'
import ModalTabelaOperadora from '@/components/RemuneracaoMedica/contratos/modais/ModalTabelaOperadora.vue'
import ViewFinanceiroTabelaPropria from '@/views/financeiro-tabela-propria.vue'

@Component({
  components: {
    ModalTabelaPrestador,
    ModalTabelaProfissional,
    ModalTabelaOperadora,
    ViewFinanceiroTabelaPropria
  }
})
export default class ComponentModalCriarTabelaPreco extends Vue {
  tab: any = 'capa'

  loadSave: boolean = false
  $refs!: { form: any }

  form: any = {
    valid: true,
    nome: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get isEdit() { return this.getFinanceiroStore.isEdit }

  get loadingSave() { return this.loadSave }
  set loadingSave(value: boolean) { this.loadSave = value }

  get modalTabelaPreco() { return this.getFinanceiroStore.modal.criarTabelaPreco }
  set modalTabelaPreco(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarTabelaPreco', value }) }

  get nome() { return this.getFinanceiroStore.nome }
  set nome(value: string) { this.getFinanceiroStore.setNome(value) }

  get equipeId() { return this.getFinanceiroStore.equipeIdSelected }
  set equipeId(value: any) { this.getFinanceiroStore.setEquipeIdSelected(value) }

  get hospitalId() { return this.getFinanceiroStore.hospitalIdSelected }
  set hospitalId(value: any) { this.getFinanceiroStore.setHospitalIdSelected(value) }

  get pontuacao() { return this.getFinanceiroStore.pontuacaoSelected }
  set pontuacao(value: any) { this.getFinanceiroStore.setPontuacaoSelected(value) }

  get equipesItems() { return this.getFinanceiroStore.equipesOptions || [] }
  get hospitaisItems() { return this.getFinanceiroStore.fontePagadoras || [] }

  get pontuacaoItems() {
    const items = this.getFinanceiroStore.itemsSenioridade || []
    const item = this.getFinanceiroStore.itemTabelaPreco
    const pontuacaoJaNaLista = items.some((p: any) => p.id === item.pontuacaoId)

    if (item.pontuacaoId && item.pontuacaoNome && !pontuacaoJaNaLista) {
      return [...items, { id: item.pontuacaoId, nome: item.pontuacaoNome, codigoPontuacao: item.pontuacaoCodigo }]
    }

    return items
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  searchPontuacao: string = ''
  loadingPontuacao: boolean = false

  debouncePontuacao = _.debounce(() => this.getFinanceiroStore.getAllItemsSenioridade(), 300)

  getPontuacaoText(item: any) {
    return `Nome: ${item.nome} - Cód.: ${item.codigoPontuacao}`
  }

  async onSearchPontuacao(val: any | Event) {
    if (val) {
      val = val.target.value

      if (val.length < 2) {
        this.getFinanceiroStore.setFiltroCodigoPontuacaoOuNome('')
        return
      }

      this.loadingPontuacao = true
      this.getFinanceiroStore.setFiltroCodigoPontuacaoOuNome(val)
      await this.debouncePontuacao()
      this.loadingPontuacao = false
    } else {
      this.getFinanceiroStore.setFiltroCodigoPontuacaoOuNome('')
    }
  }

  async save() {
    if (this.$refs.form.validate()) {
      this.loadingSave = true
      const response = await this.getFinanceiroStore.criarTabelaPreco()
      if (response.success) {
        await this.getFinanceiroStore.getTabelaPrecoDetails(1)
        this.modalTabelaPreco = false
        EventBus.$emit('setSnackbar', { show: true, text: 'Profissional alterado com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao salvar!', icon: 'warning', color: '#C62828' })
      }
      this.loadingSave = false
    }
  }

  @Watch('modalTabelaPreco')
  async onChangeModalAlterarPrestador(value: boolean) {
    this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
    this.tab = 'capa'
  }
}
